module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_3-min.b6d0c825.jpg";